module.exports = __webpack_public_path__ + "static/media/6en.df6e13c6.jpg";